import { ActionTypes, AlertTypes } from '@tassat/ui-definitions';
import { createContext } from 'react';

export interface ConfirmationWorkflowContextState {
    confirmationWorkflowState: ConfirmationWorkflowState;
    dispatchConfirmationWorkflowAction: any;
}

export interface ConfirmationWorkflowState {
    setSelectedItem: ((data) => void) | null;
    selectedItem: any;
    alertModalType?: AlertTypes;
    alertModalOpen: boolean;
    actionType: ActionTypes;
    preActionValidationAndConfig: {
        [key in ActionTypes]?: (data) => Promise<boolean> | boolean;
    };
    validationTitle?: string;
    validationMessage?: string | React.ReactElement;
    validated?: boolean;
    actionInProgress?: boolean;
    successTitle?: string;
    successBody?: string | React.ReactElement;
    failureTitle?: string;
    failureBody?: string | React.ReactElement;
    onConfirm: {
        [key in ActionTypes]?: (data) => Promise<any> | null;
    };
    onCancel?: () => void | null;
    confirmTitle?: string;
    confirmBody?: string | React.ReactElement;
    confirmModalOpen: boolean;
    useTimeout?: boolean;
}

export const DEFAULT_INITIAL_STATE: ConfirmationWorkflowState = {
    setSelectedItem: null,
    selectedItem: null,
    alertModalType: AlertTypes.message,
    alertModalOpen: false,
    actionType: ActionTypes.add,
    preActionValidationAndConfig: {},
    validationTitle: '',
    validationMessage: '',
    validated: false,
    actionInProgress: false,
    successTitle: '',
    successBody: '',
    failureTitle: '',
    failureBody: '',
    onConfirm: null as any,
    onCancel: undefined,
    confirmTitle: '',
    confirmBody: '',
    confirmModalOpen: false,
    useTimeout: false
};

const ConfirmationWorkflowContext = createContext<ConfirmationWorkflowContextState | null>(null);

export default ConfirmationWorkflowContext;